import { Alert } from "flowbite-react";
import TitleStripe from "../../common/TitleStripe";
import { formatToReal } from "../../../utils/utils";

const PROFILE_TIERS = [
  {
    key: "limiteCredito1",
    badge: "P1",
    title: "Perfil Arriscado",
    tone: {
      border: "border-rose-200",
      from: "from-rose-50",
      title: "text-rose-700",
      value: "text-rose-900",
      pill: "bg-rose-100 text-rose-700",
      bar: "bg-rose-500",
    },
  },
  {
    key: "limiteCredito2",
    badge: "P2",
    title: "Perfil Moderado",
    tone: {
      border: "border-amber-200",
      from: "from-amber-50",
      title: "text-amber-700",
      value: "text-amber-900",
      pill: "bg-amber-100 text-amber-700",
      bar: "bg-amber-500",
    },
  },
  {
    key: "limiteCredito3",
    badge: "P3",
    title: "Perfil Conservador",
    tone: {
      border: "border-emerald-200",
      from: "from-emerald-50",
      title: "text-emerald-700",
      value: "text-emerald-900",
      pill: "bg-emerald-100 text-emerald-700",
      bar: "bg-emerald-500",
    },
  },
];

function normalizeReferenceDate(value) {
  if (!value) return "Indisponível";
  const text = String(value).trim();
  if (!text) return "Indisponível";
  if (/undefined|null/i.test(text)) return "Indisponível";
  return text;
}

function formatCurrency(value) {
  if (value === null || value === undefined || value === "")
    return "Indisponível";
  const formatted = formatToReal(value);
  if (formatted === "R$ -") return String(value);
  return formatted;
}

function parsePercent(value) {
  if (value === null || value === undefined || value === "") return null;
  if (typeof value === "number" && Number.isFinite(value)) return value;
  const match = String(value).match(/[\d,.]+/);
  if (!match) return null;
  const numeric = Number(match[0].replace(",", "."));
  return Number.isFinite(numeric) ? numeric : null;
}

function formatPercent(value) {
  if (value === null || value === undefined || value === "")
    return "Indisponível";
  if (typeof value === "number") return `${value}%`;
  const text = String(value).trim();
  return text || "Indisponível";
}

function LimiteCreditoPJ({ data }) {
  if (!data && !data?.limiteCreditoPJ) return null;

  const source = data?.limiteCreditoPJ ?? data;
  const rawStatus = source?.statusRetorno ?? data?.statusRetorno;
  const statusRetorno =
    Number.isFinite(Number(rawStatus)) || rawStatus === 1
      ? Number(rawStatus)
      : null;

  if (statusRetorno !== 1) return null;

  const referenceDate = normalizeReferenceDate(
    source?.dataReferencia ?? data?.dataReferencia
  );

  return (
    <div>
      <TitleStripe>Limite de Crédito PJ</TitleStripe>
      {source?.erro?.texto ? (
        <Alert color="info" className="mt-4">
          {source?.erro?.texto}
        </Alert>
      ) : (
        <>
          <div className="flex gap-3 flex-row items-center justify-between mt-4">
            <div className="flex items-center gap-2 text-[11px] text-slate-500">
              Limites sugeridos por perfil de risco
            </div>
          </div>

          <div className="grid gap-4 mt-4 grid-cols-3">
            {PROFILE_TIERS.map((profile) => {
              const entry = source?.[profile.key] ?? {};
              const percentValue = parsePercent(entry?.capacidadePagamento);
              const percentLabel = formatPercent(entry?.capacidadePagamento);

              return (
                <div
                  key={profile.key}
                  className={`rounded-2xl border ${profile.tone.border} bg-gradient-to-br ${profile.tone.from} to-white p-4 shadow-sm`}
                >
                  <div className="flex items-center justify-between">
                    <div>
                      <p
                        className={`text-[11px] uppercase tracking-wide ${profile.tone.title}`}
                      >
                        {profile.title}
                      </p>
                      <p className="text-[11px] text-slate-500">
                        Valor limite sugerido
                      </p>
                    </div>
                    <span
                      className={`rounded-full px-2.5 py-0.5 text-[10px] font-semibold ${profile.tone.pill}`}
                    >
                      {profile.badge}
                    </span>
                  </div>

                  <p
                    className={`mt-3 text-2xl font-bold ${profile.tone.value}`}
                  >
                    {formatCurrency(entry?.limiteCredito)}
                  </p>

                  <div className="mt-4">
                    <div className="flex items-center justify-between text-[11px] text-slate-500">
                      <span>Capacidade de pagamento</span>
                      <span className="font-semibold text-slate-700">
                        {percentLabel}
                      </span>
                    </div>
                    <div className="mt-1 h-2 rounded-full bg-slate-100">
                      <div
                        className={`h-full rounded-full ${profile.tone.bar}`}
                        style={{
                          width: `${Math.max(
                            0,
                            Math.min(100, percentValue ?? 0)
                          )}%`,
                        }}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}

export default LimiteCreditoPJ;
